import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailForeheadLine({data, img}) {
    return (
        <MeasurementResult type="이마 주름" description='이마주름은 나이가 들면서 피부 탄력이 감소하고 장력이 약해져 형성되며, 반복적인 표정 근육의 움직임도 영향을 미치고, 햇빛 노출과 피부 건조 역시 이마주름을 심화시킵니다.' 
        score={data.score}>

            {/* 이미지 X */}
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                            img.image_cross_polar_front &&
                            <img src={img.image_cross_polar_front} />
                        }
                        {
                            img.image_mark_forehead_wrinkle_front &&
                            <img src={img.image_mark_forehead_wrinkle_front} />
                        }

                        <div className="caption">2D</div>
                    </div>
                </div>
                <DegreeSection 
                    type="이마 주름"
                    badge={data.analysisBadge}
                    level={data.level}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "경도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중간 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                    {
                        value: "중증 정도",
                        label: "8"
                    },
                    ]}
                    levelFloat={data.levelFloat}
                    text={data.degreeText}
                    line={2}
                />
            </div>

            {/* 이미지 O */}
            {/* <div className="row-wrap">
                <div className="img-wrap more justify-content-start">
                    <div className="img-cont">
                        <img src={process.env.PUBLIC_URL + "/image/img_report_result_blackhead_01.jpg"} />
                        <img src={process.env.PUBLIC_URL + "/image/img_report_result_blackhead_01_01.png"} />

                        <div className="caption">화이트 라이트</div>
                    </div>
                    <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="row-wrap">
                <DegreeSection 
                    type="이마 주름"
                    direction="row"
                    badge={data.analysisBadge}
                    level={data.level}
                    items={[
                    {
                        value: "없음",
                        level: 0
                    },
                    {
                        value: "경도",
                        level: 1
                    },
                    {
                        value: "중간 정도",
                        level: 2
                    },
                    {
                        value: "중증 정도",
                        level: 3
                    },
                    ]}
                    text={data.degreeText}
                    maxByte={168}
                />
            </div> */}

            <div className="row-wrap grow">
                
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}